import { ActionButton } from 'elements/eventView/atomic/ActionButton';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { CustomMapPage, CustomMapPageProps } from 'pages/custom/shared/CustomMapPage';
import { useRef } from 'react';
import { MapRef } from 'react-map-gl';
import styled from 'styled-components/macro';

export const TrevareFestMapWrapper = (props: CustomMapPageProps): JSX.Element => {
    const ref = useRef<MapRef>(null);
    const isWide = useIsWide();

    function goToFestivalArea() {
        const coordinates: [[number, number], [number, number]] = isWide
            ? [
                  [14.197037, 68.153871],
                  [14.202276, 68.152579]
              ]
            : [
                  [14.197037, 68.153871],
                  [14.202276, 68.152579]
              ];

        ref?.current?.fitBounds(coordinates, { animate: true, duration: 1400 });
    }

    function goToBusStops() {
        const coordinates: [[number, number], [number, number]] = isWide
            ? [
                  [14.147496, 68.242438],
                  [14.621992, 68.143852]
              ]
            : [
                  [14.147496, 68.242438],
                  [14.621992, 68.143852]
              ];

        ref?.current?.fitBounds(coordinates, { animate: true, duration: 1400 });
    }

    return (
        <CustomMapPage
            {...props}
            onMapLoaded={(mapRef) => {
                ref.current = mapRef;
            }}
            topOverflowPosition={'left'}
            topOverflow={
                <S_Buttons>
                    <S_ActionButton
                        icon={{ iconSet: 'fal', iconName: 'location-crosshairs' }}
                        text={'Festival area'}
                        highlighted={false}
                        onClick={goToFestivalArea}
                    />
                    <S_ActionButton
                        icon={{ iconSet: 'fal', iconName: 'location-crosshairs' }}
                        text={'Bus stops'}
                        highlighted={false}
                        onClick={goToBusStops}
                    />
                </S_Buttons>
            }
        />
    );
};

const S_Buttons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    pointer-events: all;
`;

const S_ActionButton = styled(ActionButton)`
    width: 100%;
    justify-content: start;
`;
